export default "__VITE_ASSET__8132c5e1__"